import { FiltersValues, initialAny } from 'components/UnitsFilters/types';
import { ANY } from '../../constants/building/availableCondos';

import { initialSearchBoxFilters } from 'components/Search/SearchInput/types';
import { initialBathsInputValue } from 'components/UnitsFilters/components/moreFiltersFields/Baths';

export const INTERCOASTAL_VIEW = 'intracoastalView';
export const PET_FRIENDLY = 'petFriendly';
export const SKYLINE_VIEW = 'skylineView';
export const FURNISHED = 'furnished';
export const UNFURNISHED = 'unfurnished';
export const OCEAN_VIEW = 'oceanView';
export const BEACH_FRONT = 'beachfront';
export const OCEAN_FRONT = 'oceanfront';
export const ANY_WATERFRONT = 'wfAny';
export const PENTHOUSE = 'penthouse';

export const defaultFilterValuesWithoutListingTypes = {
  anyPrice: initialAny,
  anyBeds: initialAny,
  baths: initialBathsInputValue,
  parkingPlaces: ANY,
  sqft: initialAny,
  yearBuild: initialAny,
  daysOnCbb: ANY,
  closedAt: ANY,
  [PET_FRIENDLY]: false,
  [FURNISHED]: false,
  [UNFURNISHED]: false,
  [INTERCOASTAL_VIEW]: false,
  [OCEAN_VIEW]: false,
  [SKYLINE_VIEW]: false,
  [OCEAN_FRONT]: false,
  [BEACH_FRONT]: false,
  [PENTHOUSE]: false,
  [ANY_WATERFRONT]: false,
  keyWords: '',
  showPendingListings: false,
  maxHOA: ANY,
  bitcoin: false,
  sellerFinancing: false,
  shortTermRent: false,
  notShortTermRent: false,
  corner: false,
  floor: initialAny,
  priceSqFt: initialAny,
  unitsInBuilding: initialAny,
  unitNumberRegex: '',
  rentalInvestments: false,
  lowDownPayment: false,
  shortTermRentTerms: [],
  notShortTermRentTerms: [],
  secretSearch: '',
  sw: '',
  ne: '',
  z: '',
};

export const defaultFilterValues: FiltersValues = {
  ...defaultFilterValuesWithoutListingTypes,
  preConstruction: false,
  newConstruction: false,
  foreclosures: false,
  shortSales: false,
  existingCondos: false,
  comingSoon: false,
  forRent: false,
  forSale: false,
  sold: false,
  searchBoxFilters: initialSearchBoxFilters,
};

export const sortOptionsV2 = {
  RECOMMENDED: 'Recommended',
  PRICE_HIGHEST_FIRST: 'Price High-Low',
  PRICE_LOWEST_FIRST: 'Price Low-High',
  SQUARE_FEET: 'Square Feet',
  BEDROOMS: 'Bedrooms',
  RECENT_CHANGES: 'Recent Changes',
};

export const defaultSortOption = sortOptionsV2.RECOMMENDED;

export const SEARCH_SALE_FILTERS = {
  preConstruction: true,
  newConstruction: true,
  foreclosures: true,
  shortSales: true,
  existingCondos: true,
  comingSoon: true,
  forSale: true,
  sortOption: defaultSortOption,
};

export const SEARCH_RENT_FILTERS = {
  forRent: true,
  sortOption: defaultSortOption,
};
